// Google Analytics helper functions
export const gtag = (...args) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag(...args);
  }
};

// Enhanced Ecommerce Events
export const trackPageView = (url, title) => {
  gtag('event', 'page_view', {
    page_location: url,
    page_title: title,
  });
};

export const trackProductView = (product) => {
  gtag('event', 'view_item', {
    currency: 'TRY',
    value: product.price,
    items: [{
      item_id: product.id,
      item_name: product.name,
      price: product.price,
      quantity: 1,
      item_category: product.category,
      item_variant: product.variant
    }]
  });
};

export const trackAddToCart = (product, quantity = 1) => {
  gtag('event', 'add_to_cart', {
    currency: 'TRY',
    value: product.price * quantity,
    items: [{
      item_id: product.id,
      item_name: product.name,
      price: product.price,
      quantity: quantity,
      item_category: product.category,
      item_variant: product.variant
    }]
  });
};

export const trackRemoveFromCart = (product, quantity = 1) => {
  gtag('event', 'remove_from_cart', {
    currency: 'TRY',
    value: product.price * quantity,
    items: [{
      item_id: product.id,
      item_name: product.name,
      price: product.price,
      quantity: quantity,
      item_category: product.category,
      item_variant: product.variant
    }]
  });
};

export const trackBeginCheckout = (cartItems, totalValue) => {
  gtag('event', 'begin_checkout', {
    currency: 'TRY',
    value: totalValue,
    items: cartItems.map(item => ({
      item_id: item.id,
      item_name: item.name,
      price: item.price,
      quantity: item.quantity,
      item_category: item.category,
      item_variant: item.variant
    }))
  });
};

export const trackPurchase = (orderData) => {
  gtag('event', 'purchase', {
    transaction_id: orderData.orderNumber,
    value: orderData.total,
    currency: 'TRY',
    shipping: orderData.shippingCost || 0,
    items: orderData.items.map(item => ({
      item_id: item.id,
      item_name: item.name,
      price: item.price,
      quantity: item.quantity,
      item_category: item.category,
      item_variant: item.variant
    }))
  });
};

export const trackSearch = (searchTerm, resultsCount) => {
  gtag('event', 'search', {
    search_term: searchTerm,
    results_count: resultsCount
  });
};

export const trackContactFormSubmit = () => {
  gtag('event', 'generate_lead', {
    event_category: 'engagement',
    event_label: 'contact_form'
  });
};

export const trackNewsletterSignup = (email) => {
  gtag('event', 'sign_up', {
    method: 'newsletter'
  });
};

export const trackSocialShare = (method, contentType, itemId) => {
  gtag('event', 'share', {
    method: method,
    content_type: contentType,
    item_id: itemId
  });
};